export default __webpack_public_path__ + "static/media/Ecoe_logo.fcb8ea1f.svg";